"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles.js");

var _Icon = _interopRequireDefault(require("./Icon"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

const GoBackButtonStyle = (0, _styledBase.default)("a", {
  target: "ett28fv0",
  label: "GoBackButtonStyle"
})(process.env.NODE_ENV === "production" ? {
  name: "uebubq",
  styles: "display:flex;align-items:center;margin-top:50px;padding:10px;font-size:14px;"
} : {
  name: "uebubq",
  styles: "display:flex;align-items:center;margin-top:50px;padding:10px;font-size:14px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Hb0JhY2tCdXR0b24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTWtDIiwiZmlsZSI6Ii4uLy4uL3NyYy9Hb0JhY2tCdXR0b24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgeyBjb2xvcnNSYXcgfSBmcm9tICcuL3N0eWxlcy5qcyc7XG5pbXBvcnQgSWNvbiBmcm9tICcuL0ljb24nO1xuXG5jb25zdCBHb0JhY2tCdXR0b25TdHlsZSA9IHN0eWxlZC5hYFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuXG4gIG1hcmdpbi10b3A6IDUwcHg7XG4gIHBhZGRpbmc6IDEwcHg7XG5cbiAgZm9udC1zaXplOiAxNHB4O1xuYDtcblxuY29uc3QgQnV0dG9uVGV4dCA9IHN0eWxlZC5wYFxuICBjb2xvcjogJHtjb2xvcnNSYXcuZ3JheX07XG4gIG1hcmdpbjogMCAxMHB4O1xuYDtcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgR29CYWNrQnV0dG9uIGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50IHtcbiAgcmVuZGVyKCkge1xuICAgIHJldHVybiAoXG4gICAgICA8R29CYWNrQnV0dG9uU3R5bGUgaHJlZj17dGhpcy5wcm9wcy5ocmVmfT5cbiAgICAgICAgPEljb24gdHlwZT1cImFycm93XCIgc2l6ZT1cInNtYWxsXCIgLz5cbiAgICAgICAgPEJ1dHRvblRleHQ+R28gYmFjayB0byBzaXRlPC9CdXR0b25UZXh0PlxuICAgICAgPC9Hb0JhY2tCdXR0b25TdHlsZT5cbiAgICApO1xuICB9XG59XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const ButtonText = (0, _styledBase.default)("p", {
  target: "ett28fv1",
  label: "ButtonText"
})("color:", _styles.colorsRaw.gray, ";margin:0 10px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Hb0JhY2tCdXR0b24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0IyQiIsImZpbGUiOiIuLi8uLi9zcmMvR29CYWNrQnV0dG9uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgY29sb3JzUmF3IH0gZnJvbSAnLi9zdHlsZXMuanMnO1xuaW1wb3J0IEljb24gZnJvbSAnLi9JY29uJztcblxuY29uc3QgR29CYWNrQnV0dG9uU3R5bGUgPSBzdHlsZWQuYWBcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcblxuICBtYXJnaW4tdG9wOiA1MHB4O1xuICBwYWRkaW5nOiAxMHB4O1xuXG4gIGZvbnQtc2l6ZTogMTRweDtcbmA7XG5cbmNvbnN0IEJ1dHRvblRleHQgPSBzdHlsZWQucGBcbiAgY29sb3I6ICR7Y29sb3JzUmF3LmdyYXl9O1xuICBtYXJnaW46IDAgMTBweDtcbmA7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIEdvQmFja0J1dHRvbiBleHRlbmRzIFJlYWN0LkNvbXBvbmVudCB7XG4gIHJlbmRlcigpIHtcbiAgICByZXR1cm4gKFxuICAgICAgPEdvQmFja0J1dHRvblN0eWxlIGhyZWY9e3RoaXMucHJvcHMuaHJlZn0+XG4gICAgICAgIDxJY29uIHR5cGU9XCJhcnJvd1wiIHNpemU9XCJzbWFsbFwiIC8+XG4gICAgICAgIDxCdXR0b25UZXh0PkdvIGJhY2sgdG8gc2l0ZTwvQnV0dG9uVGV4dD5cbiAgICAgIDwvR29CYWNrQnV0dG9uU3R5bGU+XG4gICAgKTtcbiAgfVxufVxuIl19 */"));

class GoBackButton extends _react.default.Component {
  render() {
    return (0, _core.jsx)(GoBackButtonStyle, {
      href: this.props.href
    }, (0, _core.jsx)(_Icon.default, {
      type: "arrow",
      size: "small"
    }), (0, _core.jsx)(ButtonText, null, "Go back to site"));
  }

}

exports.default = GoBackButton;